const redirects = {
  // Backlinks to the following
  '/press-release-feb-2015': '/about',
  '/podcast': '/',
  '/video-interviews': '/',
  '/partnership-program/technology-partners/apply': '/partnership-program/apply',
  '/partnership-program/network-and-community-partners/apply': '/partnership-program/apply',
  '/partnership-program/venture-capital-partners/apply': '/partnership-program/apply',
  '/partnership-program/hr-consultants-partners/apply': '/partnership-program/apply',
  '/partnership-program/venture-capital-partners': '/partnership-program/channel-partners',
  '/partnership-program/network-and-community-partners': '/partnership-program/channel-partners',
  '/partnership-program/hr-consultants-partners': '/partnership-program/channel-partners',
  '/branded-boards': '/'
};

const redirectedPaths = Object.keys(redirects);

module.exports = redirects;
module.exports.redirectedPaths = redirectedPaths;
